export default __webpack_public_path__ + "static/media/DSC04903.65d984d4.jpg";